// Compact, reusable search input. Keeps its own testids so pages that use it
// get a consistent layout and clear-button behaviour.
import { Search, X } from "lucide-react";

export default function SearchBar({ value, onChange, placeholder = "Search…", resultLabel = null }) {
    return (
        <section className="relative" data-testid="search-bar">
            <Search size={16} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[var(--text-muted)] pointer-events-none" />
            <input
                data-testid="search-input"
                type="search"
                value={value}
                onChange={e => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full rounded-full pl-10 pr-10 py-3 text-sm bg-white border border-[var(--border-soft)] focus:outline-none focus:ring-2 focus:ring-[var(--pine)]/30 focus:border-[var(--pine)]"
            />
            {value && (
                <button
                    data-testid="clear-search-btn"
                    onClick={() => onChange("")}
                    className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-full text-[var(--text-muted)] hover:text-black hover:bg-[var(--surface-soft)]"
                    aria-label="Clear search">
                    <X size={14} />
                </button>
            )}
            {resultLabel && (
                <div className="mt-2 text-xs text-[var(--text-muted)]" data-testid="search-result-count">
                    {resultLabel}
                </div>
            )}
        </section>
    );
}
